module.exports = __webpack_public_path__ + "img/deepvalv-draw.c8b9721b.jpg";